import endpoints from "../config/endpoints";
import api from "../config/axios";

export const AddToCart = async (cartData) => {
    try {
        const response = await api.post(endpoints.Cart.AddToCart, cartData);

        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error adding to cart:', error);
        throw error;
    }
};

export const GetCart = async (params) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`${endpoints.Cart.GetCartItems}?${query}`);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching cart:', error);
        throw error;
    }
};

export const RemoveCartItem = async (itemId) => {
    try {
        const response = await api.delete(`${endpoints.Cart.RemoveCartItem}?cartItemId=${itemId}`);

        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error removing cart item:', error);
        throw error;
    }
};

export const MoveItemToCartOrWishlist = async (params) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.put(`${endpoints.Cart.MoveToCartOrWishlist}?${query}`);

        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error Move cart item:', error);
        throw error;
    }
};

export const UpdateCartItem = async (id,cartItem) => {
    try {
        const response = await api.put(`${endpoints.Cart.UpdateCartItem}?Id=${id}`, cartItem);

        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error Move cart item:', error);
        throw error;
    }
};

export const MoveFromOrderToCart = async (params) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.put(`${endpoints.Cart.MoveFromOrderToCart}?${query}`);

        return {
            data: response.data.data || null,
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error Move order item to cart:', error);
        throw error;
    }
};

const cartService = {
    AddToCart,
    GetCart,
    RemoveCartItem,
    MoveFromOrderToCart
};

export default cartService;
